module.exports = __webpack_public_path__ + "img/6.fb2fb799.jpeg";